module.exports = __webpack_public_path__ + "img/hsg-product-two.38b14384.png";